import { ScenarioNodeDto } from "../../components/Admins/Types/types";
import { axiosClient } from "../axiosClient";

export const createScenariosNodeApi = async (dto: ScenarioNodeDto) => {
    return await axiosClient.post<ScenarioNodeDto>(`/ScenarioNodes`, dto);
};

export const getScenariosNodeApi = async () => {
    return await axiosClient.get<ScenarioNodeDto[]>(`/ScenarioNodes`);
}

export const deleteScenarioNodeApi = async (id: number) => {
    return await axiosClient.delete<boolean>(`/ScenarioNodes/${id}`)
}

export const updateScenarioNodeApi = async(dto:ScenarioNodeDto)=>{
    return await axiosClient.put<ScenarioNodeDto>(`/ScenarioNodes/${dto.id}`, dto)
}
